import AnalyticsExpensesForm from './component'

export default AnalyticsExpensesForm
